import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  ClickAwayListener,
  Divider,
  Checkbox,
  Chip,
  Icon,
  Popper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  ListSubheader,
} from '@material-ui/core';
import { Fragment } from 'react';


class ListFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prevSelected: [],
      selected: this.props.selected || [],
      label: this.props.label || '',
      disabled: this.props.disabled || false,
    };
  }

  componentDidUpdate(prevProps) {
    if ((JSON.stringify(prevProps.selected) !== JSON.stringify(this.props.selected)) || (JSON.stringify(prevProps.label) !== JSON.stringify(this.props.label))) {
      this.setState({
        selected: this.props.selected || [],
        label: this.props.label || '',
      })
    }
  }

  handleToggle = (value) => {
    if (this.props.multiple === true) {
      const currentIndex = this.state.selected.indexOf(value);
      const newChecked = [...this.state.selected];

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      this.setState(state => ({ selected: newChecked }), this.handleChange);

    } else {
      const newChecked = [value]
      this.setState({ selected: newChecked}, this.handleChange);
    }
  }

  handleDelete = () => {
    this.setState(state => ({ selected: (this.props.defaultSelected || []), prevSelected: state.selected }), this.handleChange);
  }

  handleChange = () => {
    if (this.state.prevSelected !== this.state.selected && !this.props.readonly && (!this.props.updateAfterClose || (this.props.updateAfterClose === true && this.state.open === false))) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value: {
            [this.props.name]: this.state.selected,
          }
        }
      })
    }
  }

  renderButtonLabel() {
    return this.props.multiple === true ? (this.state.selected.length < 1 ? this.state.label : `${this.state.label} (${this.state.selected.length})`) : this.state.label
  }

  render() {
    const { classes, maxSelected, defaultSelected, description, multiple, buttonIcon, buttonIconSelected } = this.props;
    const { selected, disabled } = this.state;

    return(
      <div role="tab" className={classes.root}>
        <Chip
          disabled={disabled}
          aria-owns={null}
          aria-haspopup="true"
          buttonRef={node => { this.anchorEl = node; }}
          classes={{root: classes.chipRoot, avatar: classes.chipAvatar, icon: classes.chipIcon, colorPrimary: classes.chipSelected, label: (this.state.label === '' ? classes.labelBlank : '') }}
          label={this.renderButtonLabel()}
          clickable={true}
          color={(selected && selected.length > 0 && selected[0] !== defaultSelected[0]) ? "primary" : "default"}
          onClick={!(selected && selected.length > 0 && selected[0] !== defaultSelected[0]) ? this.handleToggle.bind(this, true) : this.handleDelete}
          icon={<Icon className={[(selected && selected.length > 0 && selected[0] !== defaultSelected[0]) ? classes.iconSelected : classes.icon, "material-icons-outlined notranslate"]}>{(selected && selected.length > 0 && selected[0] !== defaultSelected[0]) ? buttonIconSelected : buttonIcon}</Icon>}
        />
      </div>
    )
  }
}

const styles = theme => ({
  popper: {
    top: '4px !important',
    // left: '1px !important',
    // textAlign: 'left',
    zIndex: 100,
  },
  root: {
    fontSize: 12,
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.87)',
    display: 'inline-flex',
    position: 'relative',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    lineHeight: '1.4em',
    marginRight: 10,
    marginTop: 0,
    textAlign: 'left',
  },
  list: {
    maxWidth: 360,
    minWidth: 220,
    // boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    // borderRadius: 3,
    backgroundColor: '#fff',
    padding: '10px 10px 25px 10px',
    marginRight: 10,
    boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    border: '1px solid #f5f5f5',
    borderRadius: 25,
    fontWeight: 600,
  },
  listItemRoot: {
    borderRadius: 25,
    marginBottom: 3,
  },
  listItemSelected: {
    backgroundColor: 'rgba(7, 195, 153, 0.10) !important',
    // backgroundColor: '#fff !important',
  },
  primaryText: {
    fontSize: 13,
    fontWeight: 600,
  },
  secondaryText: {
    fontSize: 12,
    fontWeight: 500,
  },
  icon: {
    fontSize: 21,
    fontWeight: 400,
    marginTop: 0,
    marginRight: -10,
    marginLeft: -7,
    padding: '10px !important',
    verticalAlign: 'middle',
    color: '#585858',
  },
  iconSelected: {
    fontSize: 21,
    fontWeight: 400,
    marginTop: 0,
    marginRight: -10,
    marginLeft: -7,
    padding: '10px !important',
    verticalAlign: 'middle',
    color: '#02c39a',
  },
  chipSelected: {
    backgroundColor: '#07c3991a !important',
    boxShadow: 'none !important',
    border: '1px solid #02c39a !important',
  },
  chipRoot: {
    padding: '20px 10px 20px 10px',
    borderRadius: 50,
    marginRight: 0,
    marginBottom: 10,
    // boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    fontWeight: 500,
    fontSize: 14,
    border: '1px solid #ddd',
    backgroundColor: '#fff',

    '&:hover': {
      boxShadow: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  chipAvatar: {
    width: '44px !important',
    height: '44px !important',
    marginRight: '4px !important',
  },
  labelBlank: {
    padding: 1,
  },
});

export default withStyles(styles)(ListFilter);